import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { SafePipe } from '@shared/pipes/safe.pipe';

@Component({
  selector: 'formly-innerhtml',
  imports: [SafePipe],
  template: `
    <div class="ql-show">
      <div class="ql-editor bg-primary-100/80 p-2 rounded-md text-gray-800" [innerHTML]="formControl.value | safe:'html'"></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InnerHtmlComponent extends FieldType {

}
